<template>
    <CenterBox
        :pageID="1031"
        @permissionData="(data) => {
            this.permissionDetails = data
        }"
    >
        <h4>{{ $t('sys_change_pw') }}</h4>
        <hr>
        <div style="text-align: left;width: 80%;margin: auto">
            <h5>{{ $t('sys_change_new_pw') }}</h5>
            <input type="password" class="form-control" width="200px" v-model="newPw1">
            <h5>{{ $t('sys_change_re_type_pw') }}</h5>
            <input type="password" class="form-control" width="200px" v-model="newPw2">
        </div>
        <button class="btn btn-primary" style="width: 200px;margin: 10px auto auto auto" @click="checkPWSame">
            {{ $t('common_confirm') }}
        </button>
        <div v-if="error">
            <hr>
            <h5 class="error-text">{{ error }}</h5>
            <p class="error-text">{{ errorDetails}}</p>
        </div>

    </CenterBox>
</template>

<script>

import CenterBox from "@/components/routerViewLocation/CenterBox";
export default {
    name: "SystemUserChangePasswordView",
    components: {CenterBox},
    data(){
        return{
            permissionDetails: {},
            newPw1: '',
            newPw2: '',

            error: '',
            errorDetails: '',
        }
    },
    methods: {
        async checkPWSame(){
            this.error = ""
            this.errorDetails = ""
            if(this.newPw1 && this.newPw2){
                if(this.newPw1 === this.newPw2){
                    this.$store.commit('setIsTopLoading', true)
                    await this.$mainApi.put('api/client/update-password/', {
                        "newPassword": this.newPw2,
                        "userServerID": this.$store.state.userServerID
                    })
                        .then(response => {
                            if(response.data.status === 80){
                                this.$toast.success(this.$t('common_success'))
                            }else{
                                this.error = response.data.errors
                                this.errorDetails = response.data.details
                            }
                        })
                    this.$store.commit('setIsTopLoading', false)
                }else{
                    this.error = "Re-type Password not same"
                }
            }else{
                this.error = "Password Cannot be Empty"
            }
        }
    },
    mounted() {
        document.title = this.$t('title') + ' | ' + this.$t('change_pw')
    }
}
</script>

<style scoped>

</style>
